var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.showPrivateNavbar == 'true')?_c('Aside'):_vm._e(),(this.showPublicNavbar == 'true')?_c('NavBar'):_vm._e(),_c('v-main',{staticClass:"py-5",staticStyle:{"background-color":"#f8f9fa !important"},attrs:{"app":""}},[_c('router-view')],1),(this.showPublicFooter == 'true')?_c('Footer',{attrs:{"slot":""},slot:"default"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }